export default __webpack_public_path__ + "b139728.png";